export default "__VITE_ASSET__1af45586__"